"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const assets_1 = require("~/assets");
const SortingDropdown_module_scss_1 = __importDefault(require("./SortingDropdown.module.scss"));
function SortingDropdown({ options, field, order, disabled, setField, setOrder }) {
    const selectedOrderIcon = order === 'ASC' ? assets_1.svgSystemChevronUp : assets_1.svgSystemChevronDown;
    return (react_1.default.createElement("div", { className: SortingDropdown_module_scss_1.default.dropdown }, options.map((option) => {
        const key = Object.keys(option)[0];
        const isSelected = key === field;
        const clickHandler = isSelected
            ? {
                onClick: () => {
                    if (!disabled) {
                        setOrder(order === 'ASC' ? 'DESC' : 'ASC');
                    }
                },
            }
            : {
                onClick: () => {
                    if (!disabled) {
                        setField(key);
                        setOrder('ASC');
                    }
                },
            };
        return (react_1.default.createElement("div", Object.assign({ className: SortingDropdown_module_scss_1.default.option, key: key }, clickHandler),
            react_1.default.createElement("span", { "data-selected": isSelected }, option[key]),
            react_1.default.createElement("img", { "data-selected": isSelected, src: isSelected ? selectedOrderIcon : assets_1.svgSystemChevronUp, alt: "Dropdown icon" })));
    })));
}
exports.default = SortingDropdown;
